import { forwardRef } from 'react';
import type { InputHTMLAttributes, LabelHTMLAttributes, SelectHTMLAttributes, TextareaHTMLAttributes } from 'react';
import { cn } from '../../shared/cn';

export function Label({ className, ...props }: LabelHTMLAttributes<HTMLLabelElement>) {
  return <label className={cn('text-sm font-medium text-[#4f5d49]', className)} {...props} />;
}

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(function Input({ className, ...props }, ref) {
  return <input ref={ref} className={cn('h-9 rounded-md border border-[#d6ded0] bg-white px-3 text-sm text-[#223126] shadow-sm transition-colors duration-200 placeholder:text-[#9ba592] focus:border-[#75816a] focus:outline-none focus:ring-2 focus:ring-[#dfe8d8] disabled:cursor-not-allowed disabled:bg-[#f4f7f1] disabled:opacity-70', className)} {...props} />;
});

export function Select({ className, ...props }: SelectHTMLAttributes<HTMLSelectElement>) {
  return <select className={cn('h-9 min-w-0 max-w-full truncate rounded-md border border-[#d6ded0] bg-white px-3 text-sm text-[#223126] shadow-sm transition-colors duration-200 focus:border-[#75816a] focus:outline-none focus:ring-2 focus:ring-[#dfe8d8]', className)} {...props} />;
}

export function Textarea({ className, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea className={cn('min-h-20 rounded-md border border-[#d6ded0] bg-white px-3 py-2 text-sm text-[#223126] shadow-sm transition-colors duration-200 placeholder:text-[#9ba592] focus:border-[#75816a] focus:outline-none focus:ring-2 focus:ring-[#dfe8d8]', className)} {...props} />;
}

export function FieldError({ message }: { message?: string }) {
  if (!message) return null;
  return <p className="text-xs text-rose-600">{message}</p>;
}
